import { ROOM_RESERVATIONS_PERMISSIONS } from '@/constants'

export default [
    {
        path: '/administration',
        name: 'administration',
        component: () => import('@/views/Administration/Index.vue'),
        meta: {
            title: 'administration.root.pageTitle',
            menuRendered: true,
            menuTitle: 'administration.root.menuTitle',
            icon: 'mdi-domain'
        },
        children: [
            {
                path: '/administration/room-reservations',
                name: 'administrationRoomReservations',
                component: () => import('@/views/Administration/RoomReservationsNew/Index.vue'),
                meta: {
                    title: 'administration.roomReservations.pageTitle',
                    menuRendered: true,
                    menuTitle: 'administration.roomReservations.menuTitle',
                    requiresAuth: true,
                    permission: 'room_reservations'
                }
            },
            {
                path: '/administration/room-reservations-new',
                name: 'administrationRoomReservationsNew',
                component: () => import('@/views/Administration/RoomReservations/Index.vue'),
                meta: {
                    title: 'administration.roomReservations.legacyPageTitle',
                    menuRendered: true,
                    menuTitle: 'administration.roomReservations.legacyMenuTitle',
                    requiresAuth: true,
                    permission: ROOM_RESERVATIONS_PERMISSIONS.NEW
                }
            },
            {
                path: '/administration/users',
                name: 'administrationUsers',
                component: () => import('@/views/Administration/Users/Index.vue'),
                meta: {
                    title: 'administration.users.pageTitle',
                    menuRendered: true,
                    menuTitle: 'administration.users.menuTitle',
                    requiresAuth: true,
                    permission: 'superadmin'
                }
            },
            {
                path: '/administration/cost-center-numbers',
                name: 'administrationCostCenterNumbers',
                component: () => import('@/views/Administration/CostCenterNumbers/Index.vue'),
                meta: {
                    title: 'administration.costCenterNumbers.pageTitle',
                    menuRendered: true,
                    menuTitle: 'administration.costCenterNumbers.menuTitle',
                    requiresAuth: true,
                    permission: 'finances'
                }
            }
        ]
    }
]
